import { useTranslation } from 'react-i18next'

import { wwtMemo } from '@wwt/custom/wwt'

import { wwtPerformanceLog } from '@wwt/core/admin'

import { ReservationTabTemplateForSideBlockElement } from './ReservationTabTemplateForSideBlockElement.tsx'

interface ReservationTabIsEverythingCorrectProps {
	className?: string
}

/**
 * Component for show everything correct block with button for change
 *
 * @author Ivan Shchedrovskyi
 */
export const ReservationTabIsEverythingCorrect = wwtMemo(
	(props: ReservationTabIsEverythingCorrectProps) => {
		const { t } = useTranslation('room-page', {
			keyPrefix: 'reservationTab.isEverythingCorrect'
		})

		wwtPerformanceLog('ReservationTabIsEverythingCorrect')

		return (
			<ReservationTabTemplateForSideBlockElement
				title={t('title')}
				description={t('description')}
				buttonText={t('buttonText')}
				isImplemented={false}
				{...props}
			/>
		)
	}
)
